export default {"src":"/_next/static/media/star_circle_outlined_blue.55727aa7.svg","height":222,"width":218,"blurWidth":0,"blurHeight":0};